import ajaxRequest from './ajax'
import qs from "qs"

export const me = () => {
    return ajaxRequest.get("user/me")
}

export const update_me = params => {
    return ajaxRequest.post("user/update_me", params)
}

//获取用户列表
export const get_user_list = params => {
    return ajaxRequest.post('user/get_user_list', params);
}

//新增更新用户
export const add_or_update_user = body => {
    return ajaxRequest.post('user/add_or_update_user', body);
}



// 验证邮箱
export const begin_phone_email_verfication = params => {
  return ajaxRequest.post("user/begin_phone_email_verfication", params, {headers: {"Content-Type":" application/json"}})
}

//
export const end_phone_email_verfication = params => {
  return ajaxRequest.post("user/end_phone_email_verfication", params)
}

//下载模板表格
export const get_upload_user_template = () => {
    return ajaxRequest.get('user/get_upload_user_template', { responseType: 'blob' });
}

// 上传用户列表
export const upload_user = params => {
    return ajaxRequest.post("user/upload_user", params, { responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } });
}

//获取字典的值
export const load_dictionary = params => {
    return ajaxRequest.get('user/load_dictionary?' + qs.stringify(params));
}

//删除openid
export const remove_user_openid = params => {
    return ajaxRequest.post("user/remove_user_openid?" + qs.stringify(params));
}

//获取我的跳转key
export const begin_user_admin_site_promotion = () => {
    return ajaxRequest.post("user/begin_user_admin_site_promotion");
}

export const prefix_list = [
    {
        key: "+86",
        value: "+86",
    },
    {
        key: "+852",
        value: "+852",
    },
    {
        key: "+853",
        value: "+853",
    },
    {
        key: "+886",
        value: "+886",
    },
]

export const gender_list = [
    "female",
    "male"
]



// WEBPACK FOOTER //
// ./src/api/user.js